import {combineReducers} from "redux";
import list from "./list";
import upload from "./upload";
import create from "./create";
import update from "./update";
import del from "./delete";
import importProduct from "./importProduct";

export default combineReducers({list, upload, create, update, del, importProduct});
